var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 40,
    viewBox: "0 0 168 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.614 14.354h-.882L145.144 26h.864l6.606-11.646zm.036 5.508c-1.746 0-2.736 1.17-2.736 3.258 0 1.998.936 3.096 2.664 3.096 1.728 0 2.664-1.152 2.664-3.294 0-1.944-.954-3.06-2.592-3.06zm-.036.738c1.098 0 1.71.864 1.71 2.43 0 1.584-.612 2.484-1.728 2.484-1.134 0-1.746-.846-1.746-2.43 0-1.656.594-2.484 1.764-2.484zm-7.326-6.552c-1.728 0-2.736 1.152-2.736 3.168 0 2.07.936 3.204 2.664 3.204 1.71 0 2.682-1.206 2.682-3.276 0-1.98-.954-3.096-2.61-3.096zm-.036.738c1.134 0 1.728.828 1.728 2.394 0 1.62-.63 2.52-1.782 2.52-1.116 0-1.728-.864-1.728-2.412 0-1.656.612-2.502 1.782-2.502z",
    fill: "#929BA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.fa86ddcbc4d03555e88a87110e157fc1.svg";
export { ForwardRef as ReactComponent };